import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const MobileUniverse = () => {
  const { i18n, t } = useTranslation();

  const letterStyle = {
    backgroundImage: 'url(/img/v2/main/mobile/universe_letter_top.png)',
    backgroundSize: '100%',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
  };
  useEffect(() => {}, []);

  return (
    <div className="text-center relative " style={letterStyle}>
      <div className="pt-[10%] pb-[11px]  xs:px-15 overflow-hidden max-w-[100%] ">
        <div
          className={classNames(
            'breakword font-extrabold  pt-[20px] px-5 xs:px-[100px] sm:px-[180px] w-full font-TmoneyRoundWind text-xl #xxxs:text-sm xxs:text-3xl  text-[#c8be60]',
            { '#sm:!text-[22px] #sm:px-[60px]': i18n.language === 'en' },
            { ' #sm:px-[63px]': i18n.language === 'jp' }
          )}
        >
          {t('눈 떠보니 낯선 섬!')}
          <p className=" md:text-3xl breakword"> {t('여기는...?')}</p>
        </div>
        <div className="text-[#989681] font-nuniSans text-xs #xxxs:text-[9px] xxs:text-sm sm:text-xl md:text-2xl px-10  xs:px-20 breakword">
          <p className="pt-3 xxs:pt-8 underline decoration-[#e7e6de] underline-offset-4   breakword #xxs:px-[40px]">
            {t('배를 타고 놀러 가던 중, 망가져 버린 핸들!')}
            <br />
            {t('낯선 섬에 도착하면서 시작되는 이야기.')}
          </p>
          <p className="pt-4 xs:pt-8 underline decoration-[#e7e6de] underline-offset-4  breakword">
            {t('에메랄드빛 바다.')} <br />
            {t('버려진 리조트 시설.')} <br />
            {t('귀여운 동물 친구들!')} <br />
            <br />
            {t('걱정은 잠시 접고, 아름다운 섬을 둘러보세요.')} <br />
            {t('계획에 없던 뜻밖의 조난.')}
          </p>
          <p className="pt-5 xs:pt-7 underline decoration-[#e7e6de] underline-offset-4 breakword">
            {t('하지만 어쩌면, 그토록 기다리던 휴식과 만남.')} <br />
            {t('수영하고, 낚시하고, 불꽃놀이도 함께 해요!')} <br />
            {t('그들의 조난 생활이 궁금하다면?')}
          </p>
          <p className="  breakword pt-5 xs:pt-8 text-[#d0c664] cno-underline tracking-tighter font-bold underline decoration-[#e7e6de] underline-offset-4 ">
            “{t('섬, 그래 여긴 섬. 우리가 만든 작은 섬')}”
          </p>
          <p className="breakword">
            {t('7명과 당신만의 특별한 섬. 인더섬으로 어서 오세요!')}
          </p>
        </div>
      </div>
      <div className="w-full absolute mt-[-1px]">
        <img
          src="/img/v2/main/mobile/universe_letter_bottom.png"
          alt=""
          className="w-full"
        />
      </div>
    </div>
  );
};

export default observer(MobileUniverse);
